export default __webpack_public_path__ + "static/media/cup.3f944d2e.png";